/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const MessagingSection = Loadable(lazy(() => import("sections/messaging/messaging.jsx")));
const EmailConfiguration = Loadable(lazy(() => import("sections/messaging/email-config/index.jsx")));
const EmailTemplates = Loadable(lazy(() => import("sections/messaging/email-templates/index.jsx")));

const messagingRoutes = [
    {
        path: "messaging",
        element: <MessagingSection />,
    },
    {
        path: "/messaging/config",
        element: <EmailConfiguration />,
    },
    {
        path: "/messaging/email-templates",
        element: <EmailTemplates />,
    },
];
export { messagingRoutes };
